import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { IBudgetFixFlip } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetFixFlipField } from '../../../../../queries/useBudgetFixFlipField';

interface Item5Props {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const Item5: React.FC<Item5Props> = ({ required = false, propertyGuid, isReview = false }) => {
    const [item5, set_item5] = useBudgetFixFlipField<number>(
        propertyGuid,
        (b) => (b.values?.['Expand Primary Structure']?.['Item #5']?.[1] as number) ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Expand Primary Structure': { ...b.values?.['Expand Primary Structure'], 'Item #5': [b.values?.['Expand Primary Structure']?.['Item #5']?.[0] ?? '', v] as [string, number] } } })
    );
    const label = 'Item #5';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(item5)}
                />
            ) : (
                <MoneyBox
                    id={'item5'}
                    allowNegative={false}
                    value={item5}
                    onChange={(value) => set_item5(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
